<template>
  <div class="have-wiring">
    <a-form-model class="wiring_form" :colon="false" :model="queryForm" layout="inline" v-bind="layout">
      <el-row>
        <a-col :span="6">
          <a-form-model-item label="日期">
            <a-range-picker
              v-model="createTime"
              :show-time="showTime"
              format="YYYY.MM.DD"
              @ok="handleOk"
              @change="handleTimeChange"
            >
              <template #suffixIcon>
                <a-icon type="calendar" />
              </template>
            </a-range-picker>
          </a-form-model-item>
        </a-col>
        <a-col :span="6">
          <a-form-model-item label="供应商">
            <a-input
              v-model="queryForm.supplierCode"
              :max-length="100"
              placeholder="请输入供应商编码"
              @pressEnter="toSearch"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="6">
          <a-form-model-item label="仓库">
            <a-input
              v-model="queryForm.warehouseCode"
              :max-length="100"
              placeholder="请输入仓库编码"
              @pressEnter="toSearch"
            />
          </a-form-model-item>
        </a-col>
        <a-col class="form-btn" :span="6">
          <a-button @click="handleReset">重置</a-button>
          <a-button type="primary" @click="toSearch">查询</a-button>
        </a-col>
      </el-row>
    </a-form-model>
    <div v-if="selectNum!==0" class="selectTips">已选择{{selectNum}}项</div>
    <!-- :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" -->
    <a-table
      :columns="notWiringColumns"
      :data-source="dataList"
      :pagination="pagination"
      class="wiring-table table-sigle"
      row-key="id"
      @change="tableChange"
    >
      <template slot="remark" slot-scope="text">
        <a-tooltip v-if="text.length>20" placement="top">
             <template slot="title">
               <span>{{text}}</span>
              </template>
              <span>{{conductLength(text)}}</span>
          </a-tooltip>
          <span v-else>{{conductLength(text)}}</span>
      </template>
      <template slot="supplierCode" slot-scope="text">
        <a-tooltip v-if="text.length>20" placement="top">
             <template slot="title">
               <span>{{text}}</span>
              </template>
              <span>{{conductLength(text)}}</span>
          </a-tooltip>
          <span v-else>{{conductLength(text)}}</span>
      </template>
      <template slot="warehouseCode" slot-scope="text">
        <a-tooltip v-if="text.length>20" placement="top">
             <template slot="title">
               <span>{{text}}</span>
              </template>
              <span>{{conductLength(text)}}</span>
          </a-tooltip>
          <span v-else>{{conductLength(text)}}</span>
      </template>
      <template slot="action" slot-scope="text, record">
        <a class="delete-btn" @click="onDelete(record)">
          删除
        </a>
      </template>
    </a-table>
    <!-- <div class="manualWiring">
      <a-button type="primary" @click="handleManualWiring()">手动排线</a-button>
    </div> -->
    <WiringDialog ref="HaveWiringDialog" @cancel="handleCancel"/>
  </div>
</template>

<script>
import {filterNull} from '@/utils/util'
import moment from 'moment';
import { notWiringColumns ,PLAN_STATUS} from '../const'
import WiringDialog from './WiringDialog.vue'
import {planInfoDelete,getPlanInfoPage} from '../../api'

// 选框为下单多选框，值为固定枚举值，包含【7.6米】【9.6米】【12.5米】【13.5米】【15米】
export default {
  name: 'NotWiring',
  components:{
    WiringDialog,
  },
  props:{
    checkTab:{
      type:String,
      default:''
    },
    planCode: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      queryForm: {},
      dataList: [],
      createTime:[],
      showTime:{format: "HH:mm:ss",defaultValue: [moment("00:00:00", "HH:mm:ss"),moment("23:59:59", "HH:mm:ss")]},
      notWiringColumns,
      PLAN_STATUS,
      selectedRowKeys: [],
      layout: {
        labelCol: { span: 7 },
        wrapperCol: { span: 17 },
      },
      pagination: {
        current: 1,
        total: 0,
        pageSize: 10,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "30", "40", "50"],
        onShowSizeChange: (current, pageSize) => {
          this.pagination.pageSize = pageSize;
        },
        showQuickJumper: true,
        showTotal: (total) => `共 ${total} 条`,
      },
      checkedData:[],
    }
  },
  computed:{
    selectNum(){
      return  this.selectedRowKeys.length
    },
    conductLength(){
      return (text)=> {
        return text.length>20?`${text.substring(0,19)}...`:text
      }
    },
  },
  watch:{
    checkTab(){
      if(this.checkTab==='not-wiring'){
        this.fetchData()
        this.selectedRowKeys=[]
        this.checkedData=[]
      }
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    handleCancel(){
      this.checkedData=[]
      this.selectedRowKeys=[]
      this.$emit('refresh')
      this.toSearch()
    },
    handleTimeChange(value){
      if(!value.length){
        const {startCreateTime,endCreateTime,...restParmas}=this.queryForm
        this.queryForm={
          ...restParmas
        }
       this.toSearch()
      }
    },
    handleOk(value){
      const [start,end]=value
      this.queryForm={
        ...this.queryForm,
        startCreateTime:start,
        endCreateTime:end
      }
      this.toSearch()
    },   
    handleManualWiring(){
      if(!this.checkedData.length){
       this.checkedData.push({
          line: null,
          lineCode: null,
          planCode: this.planCode,
          planTime: null,
          remark: "",
          return: false,
          skuAmount: '',
          skuPallet: '',
          skuPalletUpper:null,
          supplierCode: "",
          transportPrice: null,
          warehouseCode: "",
       })
      }
      this.$refs.HaveWiringDialog.show(this.checkedData,true)
    },
    onSelectChange(selectedRowKeys) {
      if(selectedRowKeys.length>this.selectedRowKeys.length){
        const ids=this.checkedData.map(item=>item.id)
        selectedRowKeys.forEach(item=>{
          if(!ids.includes(item))
           this.checkedData.push(this.dataList.filter(row=>row.id===item)[0])
        })
      }else{
        this.checkedData.forEach((item)=>{
          if(!selectedRowKeys.length){
            this.checkedData=[]
          }else if(!selectedRowKeys.includes(item.id)){
            this.checkedData.splice(this.checkedData.indexOf(item),1)
          }
        })
      }
      this.selectedRowKeys = selectedRowKeys;
    },
    toSearch() {
      this.pagination.current = 1
      this.fetchData()
    },
   async fetchData(){
     const parmas={
        size: this.pagination.pageSize,
        page: this.pagination.current,
        sort: 'plan_time__DESC',
     }
      const query={
        planCode:this.planCode,
        status:PLAN_STATUS.TO_BE_PLAN,
        ...filterNull(this.queryForm)
      }
      const res = await getPlanInfoPage(query,parmas)
      this.dataList=res.records
      this.pagination.total=res.total
    },
    handleReset() {
      this.queryForm = {}
      this.createTime=[]
      this.toSearch()
    },
    onDelete(record) {
      this.$confirm({
        title: '是否确认删除该条数据?',
        onOk:async ()=>{
           await planInfoDelete([record.id])
          this.$message.success('删除成功')
          this.toSearch()
        },
      });
    },
    // 分页信息改变
    tableChange(pagination) {
      let { current } = pagination
      if (pagination.pageSize !== this.pagination.pageSize) {
        current = 1
      }
      this.pagination = {
        ...pagination,
        current,
      };
      this.fetchData();
    }
  }
}
</script>
<style lang="less" scoped>
.have-wiring {
  /deep/ .ant-form {
    .ant-form-item {
      width: 100%;
      margin-bottom: 24px;
    }
    .ant-calendar-picker{
      max-width: 100%;
    }
  }
  .form-btn {
    text-align: right;
    /deep/ .ant-btn {
      margin-right: 12px;
    }
  }
  .wiring-table {
    .delete-btn {
      color:#ED4934;
    }
  }
}
.selectTips {
  margin-bottom: 12px;
  color: #171717;
}
.manualWiring {
  position: absolute;
  bottom: 38px;
  z-index: 100;
}
.wiring_form {
   /deep/.ant-form-item-label {
     width: 70px;
     label{
    color: #606266;
  }
   }
}
.search_btn {
  color: #06B880;
  border-color: #06B880;
}
</style>
